/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesInvoicesDtosInvoicePositionDto,
  FacilityFlowCoreModulesInvoicesWorkflowsAddInvoicePositionRequest,
  FacilityFlowCoreModulesInvoicesWorkflowsReorderInvoicePositionsRequest,
  FacilityFlowCoreModulesInvoicesWorkflowsUpdateInvoicePositionRequest
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getInvoicePositions = () => {
/**
 * @summary Add a manual position to a draft invoice
 */
const postApiV1InvoicesInvoiceIdPositions = (
    invoiceId: string,
    facilityFlowCoreModulesInvoicesWorkflowsAddInvoicePositionRequest: FacilityFlowCoreModulesInvoicesWorkflowsAddInvoicePositionRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesInvoicesDtosInvoicePositionDto>>,) => {
      return customInstance<FacilityFlowCoreModulesInvoicesDtosInvoicePositionDto>(
      {url: `/api/v1/invoices/${invoiceId}/positions`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesInvoicesWorkflowsAddInvoicePositionRequest
    },
      options);
    }
  /**
 * @summary Update a position on a draft invoice
 */
const putApiV1InvoicesInvoiceIdPositionsPositionId = (
    invoiceId: string,
    positionId: string,
    facilityFlowCoreModulesInvoicesWorkflowsUpdateInvoicePositionRequest: FacilityFlowCoreModulesInvoicesWorkflowsUpdateInvoicePositionRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesInvoicesDtosInvoicePositionDto>>,) => {
      return customInstance<FacilityFlowCoreModulesInvoicesDtosInvoicePositionDto>(
      {url: `/api/v1/invoices/${invoiceId}/positions/${positionId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesInvoicesWorkflowsUpdateInvoicePositionRequest
    },
      options);
    }
  /**
 * @summary Remove a position from a draft invoice. Releases the ad-hoc plan entry
stamp if the position billed one.
 */
const deleteApiV1InvoicesInvoiceIdPositionsPositionId = (
    invoiceId: string,
    positionId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/invoices/${invoiceId}/positions/${positionId}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Reorder the positions of a draft invoice. The body must list every position
exactly once; positions are renumbered in the given order.
 */
const putApiV1InvoicesInvoiceIdPositionsReorder = (
    invoiceId: string,
    facilityFlowCoreModulesInvoicesWorkflowsReorderInvoicePositionsRequest: FacilityFlowCoreModulesInvoicesWorkflowsReorderInvoicePositionsRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/invoices/${invoiceId}/positions/reorder`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesInvoicesWorkflowsReorderInvoicePositionsRequest
    },
      options);
    }
  return {postApiV1InvoicesInvoiceIdPositions,putApiV1InvoicesInvoiceIdPositionsPositionId,deleteApiV1InvoicesInvoiceIdPositionsPositionId,putApiV1InvoicesInvoiceIdPositionsReorder}};
export type PostApiV1InvoicesInvoiceIdPositionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInvoicePositions>['postApiV1InvoicesInvoiceIdPositions']>>>
export type PutApiV1InvoicesInvoiceIdPositionsPositionIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInvoicePositions>['putApiV1InvoicesInvoiceIdPositionsPositionId']>>>
export type DeleteApiV1InvoicesInvoiceIdPositionsPositionIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInvoicePositions>['deleteApiV1InvoicesInvoiceIdPositionsPositionId']>>>
export type PutApiV1InvoicesInvoiceIdPositionsReorderResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getInvoicePositions>['putApiV1InvoicesInvoiceIdPositionsReorder']>>>
